import PartnershipClientAccountPage from './PartnershipClientAccountPage';

export default PartnershipClientAccountPage;
